import { useContext, useEffect, useMemo, useState } from "react";

import { ReposContext } from "@/components/contexts/repos-context.ts";

export function useAuth() {
    const ctx = useContext(ReposContext);
    if (!ctx) throw new Error("useAuth must be used inside ReposProvider");

    const authService = ctx.authService;
    const [currentUser, setCurrentUser] = useState(authService.currentUser);

    useEffect(() => {
        return authService.subscribe(() => {
            setCurrentUser(authService.currentUser);
        });
    }, [authService]);

    return useMemo(
        () => ({
            currentUser,
            currentUserIdToken: authService.idToken,
            currentFirebaseUser: authService.currentFirebaseUser,
            role: authService.currentUser?.role ?? "unassigned",
            login: authService.signInWithEmailAndPassword.bind(authService),
            logout: authService.signOut.bind(authService),
            register: authService.signUpWithEmailAndPassword.bind(authService),
            sendPasswordResetEmail: authService.sendPasswordResetEmail.bind(authService),
            updateProfile: authService.updateProfile.bind(authService),
            authed: authService.authed,
            initialized: authService.initialized,
        }),
        [authService, currentUser],
    );
}
